import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import {
	SetAppScopeDocumentTypes,
	SetAcuityDocumentTypes,
	SetGenericIntegrations,
	SetAcuityPropertyTypes,
	SetAppScopePropertyTypes,
	SetAppScopeLoanTypes,
	SetAcuityLoanTypes,
	SetAcuityLoanReasons,
	SetAppScopeLoanReasons,
	SetAcuityOccupancyTypes,
	SetAppScopeOccupancyTypes
} from '../state/actions/global-configuration.actions';

@Injectable()
export class GenericMapperTypesLoaderService implements CanActivate {
	constructor(private store: Store) {
	}

	/**
	 * Load all util lists for lender routes.
	 * @param childRoute
	 * @param state
	 */
	canActivate(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
		// eslint-disable-next-line no-async-promise-executor
		return new Promise(async resolve => {
			await this.store.dispatch(new SetAppScopePropertyTypes()).toPromise();
			await this.store.dispatch(new SetAcuityPropertyTypes()).toPromise();
			await this.store.dispatch(new SetAppScopeLoanTypes()).toPromise();
			await this.store.dispatch(new SetAcuityLoanTypes()).toPromise();
			await this.store.dispatch(new SetAcuityLoanReasons()).toPromise();
			await this.store.dispatch(new SetAppScopeLoanReasons()).toPromise();
			await this.store.dispatch(new SetAcuityOccupancyTypes()).toPromise();
			await this.store.dispatch(new SetAppScopeOccupancyTypes()).toPromise();
			await this.store.dispatch(new SetAppScopeDocumentTypes()).toPromise();
			await this.store.dispatch(new SetAcuityDocumentTypes()).toPromise();
			await this.store.dispatch(new SetGenericIntegrations()).toPromise();
			return resolve(true);
		});
	}
}
